<header>
  <h2>{{ "settings.calculations" | transloco }}</h2>
  @if (taxYearOptions) {
  <app-search-dropdown
    [attr.data-test-ref]="'year'"
    [formCtrl]="taxYear"
    [formGroup]="searchForm"
    [listOptions]="taxYearOptions"
    label="{{ 'settings.year-label' | transloco: {yearLabel} }}"
  ></app-search-dropdown>
  } @if (taxReturnTypeOptions) {
  <app-search-dropdown
    label="{{ 'settings.type' | transloco }}"
    [attr.data-test-ref]="'type'"
    [formGroup]="searchForm"
    [formCtrl]="taxReturnType"
    [listOptions]="taxReturnTypeOptions"
  ></app-search-dropdown>
  }
</header>

@if (loading) {
<div>
  <div class="ui active centered inline loader"></div>
</div>
} @if (!loading && calculationPlans?.length == 0) {
<div id="no-results">{{ "settings.no-calculations-found" | transloco }}</div>
} @if (!loading && calculationPlans?.length > 0) {
<table id="list" width="100%" cellspacing="0">
  <tbody>
    @for (calc of calculationPlans; track calc) {
    <tr [routerLink]="[calc.questionId]">
      <td>
        <strong class="question">
          @if (showQuestionId) {
          <span>{{ calc.questionId }}.</span>
          }
          {{ questionsById[calc.questionId].question }}
          @if (questionsById[calc.questionId].isGlobal) {
          <span>🌐</span>
          }
        </strong>
        <span class="trail">{{ questionsById[calc.questionId].trail }}</span>
      </td>
      <td align="right">
        @if (getCalcPlanSaved(calc)) {
        <div>{{ "settings.saved" | transloco }}</div>
        }
      </td>
      <td align="right" class="btn">
        <strong>{{ "settings.view" | transloco }}</strong>
      </td>
    </tr>
    }
  </tbody>
</table>
}
